export const dev = {
    auth0: {
        domain: 'dev-crew-time.eu.auth0.com',
        clientId: '2flfN9lqKiiIJ1hZPfPkhMNJEHrgkM49',
        audience: 'https://crew-time/api',
    }
}

export const prod = {
    auth0: {
        domain: 'dev-crew-time.eu.auth0.com',
        clientId: '2flfN9lqKiiIJ1hZPfPkhMNJEHrgkM49',
        audience: 'https://crew-time/api',
    }
}